var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "cancel_schedule_send"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_887_2511",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_887_2511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cancel_schedule_send_2",
    d: "M16.975 17.7252L18.35 19.1002C18.45 19.2002 18.575 19.2502 18.725 19.2502C18.875 19.2502 19 19.2002 19.1 19.1002C19.2 19.0002 19.25 18.8752 19.25 18.7252C19.25 18.5752 19.2 18.4502 19.1 18.3502L17.75 17.0002L19.125 15.6252C19.225 15.5252 19.275 15.4002 19.275 15.2502C19.275 15.1002 19.225 14.9752 19.125 14.8752C19.025 14.7752 18.9 14.7252 18.75 14.7252C18.6 14.7252 18.475 14.7752 18.375 14.8752L17 16.2502L15.625 14.8752C15.525 14.7752 15.4 14.7252 15.25 14.7252C15.1 14.7252 14.975 14.7752 14.875 14.8752C14.775 14.9752 14.725 15.1002 14.725 15.2502C14.725 15.4002 14.775 15.5252 14.875 15.6252L16.25 17.0002L14.85 18.4002C14.75 18.5002 14.7 18.6169 14.7 18.7502C14.7 18.8835 14.75 19.0002 14.85 19.1002C14.95 19.2002 15.075 19.2502 15.225 19.2502C15.375 19.2502 15.5 19.2002 15.6 19.1002L16.975 17.7252ZM3 18.5002V5.50022C3 5.13355 3.14583 4.85438 3.4375 4.66272C3.72917 4.47105 4.04167 4.44188 4.375 4.57522L17.3 10.0002H17C16.4167 10.0002 15.8667 10.0669 15.35 10.2002C14.8333 10.3335 14.3333 10.5169 13.85 10.7502L5 7.00022V10.5002L11 12.0002L5 13.5002V17.0002L10.4 14.7002C10.2667 15.0835 10.1667 15.4627 10.1 15.8377C10.0333 16.2127 10 16.6002 10 17.0002V17.0502L4.4 19.4252C4.06667 19.5585 3.75 19.5294 3.45 19.3377C3.15 19.146 3 18.8669 3 18.5002ZM17 22.0002C15.6167 22.0002 14.4375 21.5127 13.4625 20.5377C12.4875 19.5627 12 18.3835 12 17.0002C12 15.6169 12.4875 14.4377 13.4625 13.4627C14.4375 12.4877 15.6167 12.0002 17 12.0002C18.3833 12.0002 19.5625 12.4877 20.5375 13.4627C21.5125 14.4377 22 15.6169 22 17.0002C22 18.3835 21.5125 19.5627 20.5375 20.5377C19.5625 21.5127 18.3833 22.0002 17 22.0002Z",
    fill: "#CC454D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotDelivered);
export default __webpack_public_path__ + "static/media/NotDelivered.bba9197b2bfb7e94c6df3ec246f0dd18.svg";
export { ForwardRef as ReactComponent };